import * as React from 'react';
import * as styles from "./ElementGroup.css";
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from './../../stores';
import { Element } from '../element/Element';
import { Helper } from '../../../../Helper';
import { IAIcon } from '../../../icon/Icon';
import { Environment } from '../../../../services/Environment';
import { LocalizationService } from '../../../../services/LocalizationService';
import '../../../../styles/BasicIA.css';
import { LoggingService } from '../../../../services/LoggingService';
import { IAConditionalTooltipWrapper } from '../../../tooltip/ConditionalTooltipWrapper';
import { IAReader } from '../../../reader/Reader';
import { NavigatorTargetingTooltip } from '../targetingTooltip/TargetingTooltop';

export interface IElementGroupProps {
  navigatorStore?: NavigatorStore;
  config: any;
  elements: any[];
  type: string;
  index: number;
  topItemIndex: number;
  columnIndex: number;
  width: number;
}

@inject('navigatorStore')
@observer
export class ElementGroup extends React.Component<IElementGroupProps> {
  private readonly constructorName = "NavigatorElementGroup";

  private getTargetingGroups(seperator?: string): string {
    return this.props.navigatorStore.GetUserGroupTargetingForNavigatorAnalytics(this.props.navigatorStore.navigator.megamenu.topItems[this.props.topItemIndex].elementGroups[
      this.props.columnIndex][this.props.index].targeting, this.props.navigatorStore.applicationSettings?.applicationSettings, seperator);
  }

  private onClick(trackingType: string) {
    if (!this.props.navigatorStore.isInEditMode) {
      if (!(this.props.navigatorStore.isMobile && (this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally))) {
        if (this.props.config.url != undefined && this.props.config.url != "") {
          LoggingService.trackEvent(this.constructorName, {
            ActionType: "LinkClick",
            Type: trackingType,
            Targeting: this.getTargetingGroups(),
            Title: this.props.config.headline,
            ItemId: this.props.index,
            ColumnId: this.props.columnIndex,
            TopItemId: this.props.topItemIndex,
            ItemType: "ElementGroup",
            Url: this.props.config.url,
            Tenant: this.props.navigatorStore.tenant,
            Instance: this.props.navigatorStore.instance,
            UserId: this.props.navigatorStore.token,
            Version: this.props.navigatorStore.navigator.version.id,
            PageUrl: window.location.pathname.toLowerCase(),
            SiteName: Helper.getSiteCollectionFromPath(window.location.pathname)?.toLowerCase() ?? "none",
          });
          if (!(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally)) {
            this.props.navigatorStore.isShowingMegamenu = false;
          }
        }
      }
    } else {
      if (!(this.props.navigatorStore.isInEditMode && this.props.navigatorStore.checkedOut) && !this.props.navigatorStore.isShowingAnalytics) {
        this.props.navigatorStore.toggleElementGroupSettings(this.props.topItemIndex, this.props.columnIndex, this.props.index);
      }
    }
  }

  render() {
    let iconSize: number = 20;
    let titleWidth = this.props.width;
    if (this.props.navigatorStore.isInEditMode) {
      if (this.props.config.icon != null) {
        titleWidth = titleWidth - iconSize - 10;
      }
    } else {
      if (this.props.config.icon != null) {
        titleWidth = titleWidth - iconSize - 10;
      }
    }
    let elements: JSX.Element[] = [];
    this.props.elements.forEach((element: any, elementIndex) => {
      if (element) {
        if (this.props.navigatorStore.droppableElementSpotsAreShowing) {
          elements.push(
            <div className={styles.elementDroppable}
              key={`elementDroppabl_${elementIndex}`}
              style={{
                color: this.props.navigatorStore.navigator.design.elements.textColor,
                border: `1px dashed ${this.props.navigatorStore.navigator.design.elements.textColor}`,
                opacity: 0.5
              }}
              onDragOver={() => event.preventDefault()}
              onDragEnter={() => event.preventDefault()}
              onDrop={() => {
                this.props.navigatorStore.updateElementPosition(this.props.topItemIndex, this.props.columnIndex, this.props.index, elementIndex);
              }}
            >
              {new LocalizationService().strings.Navigator_Megamenu_DropItem}
            </div>
          )
        }
        if (this.props.navigatorStore.checktargetedPreviewIds(element)) {
          elements.push(
            <Element
              key={`element_${elementIndex}`}
              type={element.type}
              config={element.config}
              topItemIndex={this.props.topItemIndex}
              columnIndex={this.props.columnIndex}
              elementGroupIndex={this.props.index}
              index={elementIndex}
              width={this.props.width}
            />
          );
        }
      }
    });
    if (this.props.navigatorStore.droppableElementSpotsAreShowing) {
      elements.push(
        <div className={styles.elementDroppable}
          key={`elementDroppable_${this.props.index}`}
          style={{
            color: this.props.navigatorStore.navigator.design.elements.textColor,
            border: `1px dashed ${this.props.navigatorStore.navigator.design.elements.textColor}`,
            marginBottom: 20,
            opacity: 0.5
          }}
          onDragOver={() => event.preventDefault()}
          onDragEnter={() => event.preventDefault()}
          onDrop={() => {
            this.props.navigatorStore.updateElementPosition(this.props.topItemIndex, this.props.columnIndex, this.props.index, this.props.elements.length);
          }}
        >
          {new LocalizationService().strings.Navigator_Megamenu_DropItem}
        </div>
      )
    }
    if (this.props.navigatorStore.isInEditMode && !this.props.navigatorStore.droppableElementGroupSpotsAreShowing && !this.props.navigatorStore.droppableElementSpotsAreShowing && !this.props.navigatorStore.droppableTopItemSpotsAreShowing) {
      elements.push(
        <div
          className={styles.elementAddNewButton}
          key={`elementAddNewButton_${this.props.index}`}
          onClick={() => {
            if (!this.props.navigatorStore.isShowingAnalytics && !this.props.navigatorStore.checkedOut) {
              this.props.navigatorStore.addElement(this.props.topItemIndex, this.props.columnIndex, this.props.index);
            }
          }}
        >
          <div
            className={styles.elementAddNewButtonIcon}
          >
            <IAIcon
              title="Add"
              size={20}
              color={this.props.navigatorStore.navigator.design.elementGroups.textColor}
            />
          </div>
          <div
            className={styles.elementAddNewButtonText}
            style={{
              color: this.props.navigatorStore.navigator.design.elementGroups.textColor
            }}
          >
            {new LocalizationService().strings.Navigator_Megamenu_AddItem}
          </div>
        </div>
      );
    }
    let heatMapColor = this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks ? this.props.navigatorStore.getHeatMapColorHSL(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks) : "";
    let heatMapBoxShadow = this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks ? `0px 0px 10px 3px ${Helper.lightenOrDarkenColor(this.props.navigatorStore.navigator.design.elementGroups.backgroundColor)} inset` : "";
    let element: JSX.Element;
    switch (this.props.type) {
      case "video":
        element = (
          <div
            className={styles.elementGroupVideo}
            style={{
              width: this.props.width,
              height: (this.props.width / 16) * 9,
              borderBottom: this.props.navigatorStore.navigator.design.elementGroups.showLine ? `${this.props.navigatorStore.navigator.design.elementGroups.lineThickness} solid ${this.props.navigatorStore.navigator.design.elementGroups.textColor}` : "none",
              //backgroundImage: this.props.config.url != undefined && Helper.isYouTubeUrl(this.props.config.url) ? `url(${Helper.getYouTubeThumbnailFromURL(this.props.config.url)}` : `url(${IMG_STREAM})`
            }}
          >
            {this.props.navigatorStore.isInEditMode &&
              <div
                style={{
                  position: "absolute",
                  width: this.props.width,
                  height: (this.props.width / 16) * 9,
                  backgroundColor: "transparent"
                }}
                onClick={() => {
                  if (!(this.props.navigatorStore.isInEditMode && this.props.navigatorStore.checkedOut) && this.props.navigatorStore.isShowingAnalytics) {
                    this.props.navigatorStore.toggleElementGroupSettings(this.props.topItemIndex, this.props.columnIndex, this.props.index);
                  }
                }}
              />
            }
            {!this.props.navigatorStore.droppableElementSpotsAreShowing && this.props.config.url &&
              <React.Fragment>
                {(this.props.config.url.indexOf(".mp4") === -1 && this.props.config.url.indexOf(".webm") === -1) ?
                  <iframe
                    width={this.props.width}
                    height={(this.props.width / 16) * 9}
                    src={Helper.isVimeoVideo(this.props.config.url) ? Helper.getVideoSrcFromEmbedCode(this.props.config.url) : this.props.config.url}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={true}
                  />
                  :
                  <video
                    width={this.props.width}
                    height={(this.props.width / 16) * 9}
                    controls
                  >
                    <source src={this.props.config.url}></source>
                  </video>
                }
              </React.Fragment>
            }
          </div>
        );
        break;
      case "text":
        element = (
          <div
            onClick={() => this.onClick("Text")}
            className={[styles.elementText, this.props.config?.url ? "IA_OnFocus" : ""].join(" ")}
            style={{
              width: this.props.width,
              borderBottom: this.props.navigatorStore.navigator.design.elementGroups.showLine ? `${this.props.navigatorStore.navigator.design.elementGroups.lineThickness} solid ${this.props.navigatorStore.navigator.design.elementGroups.textColor}` : "none",
              cursor: this.props.config.url != undefined && this.props.config.url != "" ? "pointer" : "default",
              backgroundColor: this.props.navigatorStore.isInEditMode ? (this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks) ? heatMapColor : Helper.lightenOrDarkenColor(this.props.navigatorStore.navigator.design.elementGroups.backgroundColor) : "transparent",
            }}
          >
            <IAReader
              id="IA_Reader"
              environment={this.props.navigatorStore.environment}
              token={this.props.navigatorStore.token}
              tenant={this.props.navigatorStore.tenant}
              content={this.props.config.content}
              style={{}}
              highlightColor={"orange"}
            />
          </div>
        );
        break;
      case "image":
        element = (
          <a
            data-interception={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "off" : "on"}
            target={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "_blank" : "_self"}
            onClick={() => this.onClick("ImageLink")}
            href={!this.props.navigatorStore.isInEditMode && this.props.config.url != undefined && this.props.config.url != "" ? this.props.config.url : undefined}
            className={[styles.elementGroupImage, this.props.config?.url ? "IA_OnFocus" : ""].join(" ")}
            style={{
              width: this.props.width,
              borderBottom: this.props.navigatorStore.navigator.design.elementGroups.showLine ? `${this.props.navigatorStore.navigator.design.elementGroups.lineThickness} solid ${this.props.navigatorStore.navigator.design.elementGroups.textColor}` : "none",
              cursor: this.props.config.url != undefined && this.props.config.url != "" ? "pointer" : "default"
            }}
          >
            <IAConditionalTooltipWrapper
              condition={this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks && this.props.config.url != undefined}
              tooltipContent={
                <div>
                  {this.props.navigatorStore.getClickTooltipLocalizationString(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}
                  ({this.props.navigatorStore.getPercentageOfClickComparedToAllClicks(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}%)
                </div>
              }
              wrapper={(content) =>
                <div className={styles.elementGroupImageContainer}>
                  {content}
                  <div className={styles.elementGroupImageOverlay}
                    style={{
                      width: this.props.width,
                      backgroundImage: `radial-gradient(circle, ${heatMapColor} 40%, transparent 100%)`
                    }} />
                </div>
              }
            >
              <img
                src={this.props.config.imageUrl ? Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.navigatorStore.environment), this.props.navigatorStore.tenant.replace(".sharepoint.com", ""), this.props.navigatorStore.token, this.props.config.imageUrl, this.props.navigatorStore.versions ? this.props.navigatorStore.versions[0].modifiedDate.toString().replace(/[^\d]/g, '') : "", undefined, undefined, false) : ""}
                width={this.props.width}
              />
            </IAConditionalTooltipWrapper>
          </a>
        );
        break;
      default:
        let paddingBottom = 0;
        if (this.props.navigatorStore.navigator.design.elementGroups.showLine) {
          switch (this.props.navigatorStore.navigator.design.elementGroups.fontSize) {
            case "8px":
              paddingBottom = 0;
              break;
            case "10px":
              paddingBottom = 1;
              break;
            case "12px":
              paddingBottom = 2;
              break;
            case "14px":
              paddingBottom = 3;
              break;
            case "16px":
              paddingBottom = 4;
              break;
            case "18px":
              paddingBottom = 5;
              break;
            case "20px":
              paddingBottom = 6;
              break;
          }
        }
        element = (
          <a
            data-interception={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "off" : "on"}
            target={(this.props.config.openInNewWindow || this.props.navigatorStore.loadLinksExternally) ? "_blank" : "_self"}
            onClick={() => this.onClick("Link")}
            href={!this.props.navigatorStore.isInEditMode && this.props.config.url != undefined && this.props.config.url != "" ? this.props.config.url : undefined}
            className={[styles.elementGroupHeadline, this.props.config?.url && !this.props.navigatorStore.isShowingAnalytics ? `IA_OnFocus ${styles.elementGroupHeadlineLink}` : ""].join(" ")}
            style={{
              borderBottom: this.props.navigatorStore.navigator.design.elementGroups.showLine && this.props.config.headline != null && this.props.config.headline != "" ? `${this.props.navigatorStore.navigator.design.elementGroups.lineThickness} solid ${this.props.navigatorStore.navigator.design.elementGroups.textColor}` : "none",
              color: this.props.navigatorStore.navigator.design.elementGroups.textColor,
              letterSpacing: this.props.navigatorStore.navigator.design.elementGroups.letterSpacing,
              textTransform: this.props.navigatorStore.navigator.design.elementGroups.textTransform,
              fontWeight: this.props.navigatorStore.navigator.design.elementGroups.fontWeight,
              fontSize: this.props.navigatorStore.navigator.design.elementGroups.fontSize,
              height: `${iconSize}px`,
              opacity: this.props.navigatorStore.droppableElementSpotsAreShowing && !this.props.navigatorStore.isShowingAnalytics ? 0.5 : 1,
              cursor: this.props.config.url != undefined && this.props.config.url != "" ? "pointer" : "default",
              paddingBottom: paddingBottom,
              marginBottom: this.props.navigatorStore.navigator.design.elements.padding ?? "25px"
            }}
          >
            <div
              style={{
                color: this.props.navigatorStore.navigator.design.elementGroups.textColor,
                height: `${iconSize}px`
              }}
            >
              {this.props.config.icon != null &&
                <div
                  className={styles.elementGroupLinkIcon}
                  style={{
                    width: iconSize,
                    height: iconSize,
                    padding: 0,
                  }}
                >
                  <IAIcon
                    title={this.props.config.icon}
                    size={iconSize as number}
                    color={this.props.navigatorStore.navigator.design.elementGroups.iconColor}
                  />
                </div>
              }
              <div
                className={styles.elementGroupHeadlineText}
                style={{
                  width: titleWidth,
                  lineHeight: `${iconSize}px`,
                  height: `${iconSize}px`,
                  backgroundColor: this.props.navigatorStore.isInEditMode ? (this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks) ? heatMapColor : Helper.lightenOrDarkenColor(this.props.navigatorStore.navigator.design.elementGroups.backgroundColor) : "transparent",
                  boxShadow: heatMapBoxShadow
                }}
              >
                <IAConditionalTooltipWrapper
                  condition={this.props.navigatorStore.isShowingAnalytics && this.props.navigatorStore.doneSettingClicks}
                  tooltipContent={
                    <div>
                      {this.props.navigatorStore.getClickTooltipLocalizationString(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}
                      ({this.props.navigatorStore.getPercentageOfClickComparedToAllClicks(this.props.navigatorStore.clickFilter === 'Total' ? this.props.config.clicks : this.props.config.uniqueClicks)}%)
                    </div>
                  }
                  wrapper={(content) =>
                    <>{content}</>
                  }
                >
                  {this.props.config.headline}
                </IAConditionalTooltipWrapper>
              </div>
            </div>
          </a >
        );
        break;
    }
    console.log(this.props.navigatorStore.droppableElementGroupSpotsAreShowing);
    console.log(this.props.navigatorStore.hasChanged); // Forces Mobx to rerender
    const targetingInfo = this.props.navigatorStore.isInEditMode && this.getTargetingGroups("<br />");
    return (
      <div
        className={styles.elementGroup}
        key={`elementGroup_${this.props.index}_${this.props.topItemIndex}_${this.props.columnIndex}`}
        draggable={this.props.navigatorStore.droppableElementGroupSpotsAreShowing}
        onDragStart={() => {
          this.props.navigatorStore.setDraggedElementGroup(this.props.topItemIndex, this.props.columnIndex, this.props.index);
        }}
        onDragEnd={() => {
          this.props.navigatorStore.draggedTopItemIndex = undefined;
          this.props.navigatorStore.draggedColumnIndex = undefined;
          this.props.navigatorStore.draggedElementGroupIndex = undefined;
          this.props.navigatorStore.draggedElementIndex = undefined;
        }}
        style={{
          border: this.props.navigatorStore.isInEditMode ? "1px solid #e8e8e8" : "none",
          cursor: this.props.navigatorStore.isInEditMode ? "pointer" : "default",
          marginBottom: this.props.navigatorStore.navigator.design.elementGroups.padding ?? "20px",
          fontFamily: this.props.navigatorStore.fontSlots?.heading?.fontFamily
        }}
      >
        {this.props.navigatorStore.isInEditMode && targetingInfo &&
          <NavigatorTargetingTooltip
            highlightColor={this.props.navigatorStore.highlightColor}
            targetingInfo={targetingInfo}
          />
        }
        {element}
        {elements}
      </div >
    )
  }


}